import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: CardProject
 */
export function CardProject() {
  console.log("CardProject mounted.");
}
